<template>
    <div>
        <el-dialog
            :title="title"
            width="500px"
            :visible="show"
            :before-close="beforeClose"
            v-loading="processing"
            :append-to-body="true"
            @close="onCancelClick"
        >
            <el-form
                :model="form"
                ref="form"
                label-width="150px"
                label-position="right"
                :rules="rules"
                v-loading="processing"
            >
                <el-form-item label="Treasurer" prop="display_name">
                    <el-autocomplete
                        popper-class="authenticate-autocomplete"
                        v-model="form.display_name"
                        :fetch-suggestions="searchUser"
                        placeholder="Type in name"
                        @select="onUserSelect"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                        <template slot-scope="{ item }">
                            <div class="display_name">{{ item.display_name||'UNKNOWN' }}</div>
                            <span class="email">{{ item.email }}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="Deposit Booking" prop="deposit_booking">
                    <el-switch v-model="form.deposit_booking"></el-switch>
                </el-form-item>
                <el-form-item label="Deposit Review" prop="deposit_review">
                    <el-switch v-model="form.deposit_review"></el-switch>
                </el-form-item>
                <el-form-item label="Withdraw Booking" prop="withdraw_booking">
                    <el-switch v-model="form.withdraw_booking"></el-switch>
                </el-form-item>
                <el-form-item label="Withdraw Review" prop="withdraw_review">
                    <el-switch v-model="form.withdraw_review"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-loading="processing">
                <el-button @click="onCancelClick">Cancel</el-button>
                <el-button @click="onDelete" v-if="permission" type="danger">Delete</el-button>
                <el-button @click="onSubmit" type="primary">Save</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "AdminCurrencyPermissionNew",
    components: {},
    props: {
        currency: Object,
        permission: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            form: {
                display_name: "",
                authenticate_id: null,
                currency_id: this.currency.id,
                deposit_booking: 0,
                deposit_review: 0,
                withdraw_booking: 0,
                withdraw_review: 0
            },
            selected_authenticate: "",
            showNewRole: false,
            processing: false,
            processing_search: false,
            rules: {}
        };
    },
    watch: {
        permission(newData) {
            if (newData) {
                this.form.display_name =
                    newData.display_name || this.permission.email;
                this.form.authenticate_id = newData.authenticate_id;
                this.form.currency_id = newData.currency_id;
                this.form.deposit_booking = newData.deposit_booking == 1;
                this.form.deposit_review = newData.deposit_review == 1;
                this.form.withdraw_booking = newData.withdraw_booking == 1;
                this.form.withdraw_review = newData.withdraw_review == 1;
            } else {
                this.form = {
                    display_name: "",
                    authenticate_id: null,
                    currency_id: this.currency.id,
                    deposit_booking: 0,
                    deposit_review: 0,
                    withdraw_booking: 0,
                    withdraw_review: 0
                };
            }
        },
        currency(currency) {
            if(currency) {
                this.form.currency_id = this.currency.id;
            }
        }
    },
    mounted() {
        if (this.permission) {
            this.form.display_name =
                this.permission.display_name || this.permission.email;
            this.form.authenticate_id = this.permission.authenticate_id;
            this.form.currency_id = this.permission.currency_id;
            this.form.deposit_booking = this.permission.deposit_booking == 1;
            this.form.deposit_review = this.permission.deposit_review == 1;
            this.form.withdraw_booking = this.permission.withdraw_booking == 1;
            this.form.withdraw_review = this.permission.withdraw_review == 1;
        }
    },
    computed: {
        title() {
            if (this.permission) {
                return `Edit permission on currency ${this.currency.asset_name}`;
            }
            return `Add permission on currency ${this.currency.asset_name}`;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            this.form = {
                display_name: "",
                authenticate_id: null,
                currency_id: null,
                deposit_booking: 0,
                deposit_review: 0,
                withdraw_booking: 0,
                withdraw_review: 0
            },
            this.selected_authenticate = "",
            done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        searchUser(queryString = "", callback = () => {}) {
            if (!queryString || queryString.length == 0) {
                callback([]);
                return;
            }
            let ctrl = this;
            ctrl.processing_search = true;
            let query = `authenticate`;
            // let query = `permission/treasurer`;
            let params = {
                limit: 10,
                where: `(display_name LIKE '%${queryString}%' OR email LIKE '%${queryString}%') AND activated=1 AND disabled=0 `
            }

            let endpoint = encodeURI(query);

            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    callback(data.results);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "AUTHENTICATE_ERROR",
                        message: "Get authenticate users Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing_search = false;
                });
        },
        onUserSelect(item) {
            this.form.display_name = item.display_name || item.email;
            this.form.authenticate_id = item.id;
        },
        onSubmit() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.form.currency_id = ctrl.currency.id;
            let method = "POST";
            let endpoint = `currencies/${ctrl.currency.asset_name}/permissions`;
            if (ctrl.permission) {
                method = "PATCH";
                endpoint = `currencies/${ctrl.currency.asset_name}/permissions/${ctrl.permission.id}`;
            }
            ctrl.request({
                method,
                endpoint,
                data: ctrl.form
            })
                .then(() => {
                    let message = "Permission has been added";
                    if (!ctrl.permission) {
                        message = "Permission has been updated";
                    }
                    ctrl.$message({
                        message,
                        type: "success"
                    });
                    // ctrl.loadSettingData();
                    this.form = {
                        display_name: "",
                        authenticate_id: null,
                        currency_id: null,
                        deposit_booking: 0,
                        deposit_review: 0,
                        withdraw_booking: 0,
                        withdraw_review: 0
                    },
                    this.selected_authenticate = "",
                    ctrl.onClose(true);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_PERMISSION_ERROR",
                        message: "Permission operation failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        onDelete() {
            let ctrl = this;
            ctrl.$confirm(
                `Do you wish to remove treasure permission from user ${ctrl.form.display_name} ?`,
                "Delete treasure permission",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    let method = "DELETE";
                    let endpoint = `currencies/${ctrl.currency.asset_name}/permissions/${ctrl.permission.id}`;
                    ctrl.request({
                        method,
                        endpoint
                    })
                        .then(() => {
                            let message =
                                "Treasure permission has been removed";
                            ctrl.$message({
                                message,
                                type: "success"
                            });
                            ctrl.onClose(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "CURRENCY_SETTING_ERROR",
                                message: "Remove treasure permission failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.permission-detail-item {
    display: flex;
    line-height: 26px;
    border-bottom: 1px solid #ccc;
}
.permission-detail-form-settings {
    border: 1px solid #ccc;
}
.permission-detail-item .title {
    width: 200px;
    text-align: right;
    background-color: rgba(0, 0, 0, 0.1);
    border-right: 1px solid #ccc;
}

.permission-detail-item .title span {
    padding: 0 8px;
}
.permission-detail-item .value {
    flex: 1;
}
.permission-detail-item .value span {
    padding: 0 8px;
}

.permission-detail-item:last-child {
    border-bottom: none;
}

.setting-section-title {
    font-size: 18px;
    padding: 0 8px;
    line-height: 30px;
}

.setting-section {
    padding: 8px;
}

.setting-section-content {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.permission-setting-content-items {
    display: flex;
    flex-direction: column;
}
.display_name {
    font-weight: 600;
}
</style>
